import { render, staticRenderFns } from "./pan.vue?vue&type=template&id=186ffc39&scoped=true&lang=true&"
import script from "./pan.vue?vue&type=script&lang=js&"
export * from "./pan.vue?vue&type=script&lang=js&"
import style0 from "./pan.vue?vue&type=style&index=0&id=186ffc39&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186ffc39",
  null
  
)

export default component.exports